import type { AuthValue } from '@elfsight/configurator-contracts';
import type { DemoSourceType } from '../types';
import type { VimeoSourceValue } from './types';

const previewVimeoAuth: AuthValue = {
  identity: 'b685f7f6-1164-4d38-8855-b1aa7d05c1a4',
  data: { name: 'Roman Pokhabov' },
  status: 'connected'
};

export const previewVimeoSources: DemoSourceType<VimeoSourceValue> = {
  'vimeo thefilmpoets': {
    label: 'Vimeo: @thefilmpoets',
    source: {
      platform: 'vimeo',
      connectionType: 'vimeoUser',
      id: 'kkpbpxry',
      name: 'Vimeo',
      authentication: previewVimeoAuth,
      source: 'https://vimeo.com/thefilmpoets'
    }
  },
  vimeo_staffpicks: {
    label: 'Vimeo: staffpicks',
    source: {
      platform: 'vimeo',
      connectionType: 'vimeoChannel',
      id: 'kkpbp1ry',
      name: 'Vimeo',
      authentication: previewVimeoAuth,
      source: 'https://vimeo.com/channels/staffpicks'
    }
  },
  vimeo_musicvideo: {
    label: 'Vimeo: Music Video',
    source: {
      platform: 'vimeo',
      connectionType: 'vimeoGroup',
      id: 'kkpb2xry',
      name: 'Vimeo',
      authentication: previewVimeoAuth,
      source: 'https://vimeo.com/groups/musicvideo'
    }
  },
  vimeo_marcobellone: {
    label: 'Vimeo: Marco Bellone',
    source: {
      platform: 'vimeo',
      connectionType: 'vimeoShowcase',
      id: 'kkpb3xry',
      name: 'Vimeo',
      authentication: previewVimeoAuth,
      source: 'https://vimeo.com/showcase/8643175'
    }
  },
  vimeo_thebreakthrough: {
    label: 'Vimeo: The Breakthrough',
    source: {
      platform: 'vimeo',
      connectionType: 'vimeoSpecificVideo',
      id: 'k12bpxry',
      name: 'Vimeo',
      authentication: previewVimeoAuth,
      source: 'https://vimeo.com/914864510'
    }
  }
};
